import Axios from "./axiosInterceptors";

export const GET = async (path, params = "") => {
  try {
    const response = await Axios.get(`${path}${params}`);
    if (response) {
      return {
        response: response.data,
        status: response.status,
      };
    }
  } catch (error) {
    throw(error);
  }

};

export const POST = async (path, payload = {}, headers) => {
  try {
    const response = await Axios.post(path, payload, headers);
    if (response) {
      return {
        response: response.data,
        status: response.status,
      };
    }
  } catch (error) {
    throw(error) 
  }

};

export const PUT = async (path, payload, headers) => {
  try {
    const response = await Axios.put(path, payload, headers);
    if (response) {
      return {
        response,
        status: response.status,
      };
    }
  } catch (error) {throw(error)}
};

export const PATCH = async (path, payload) => {
  try {
    const response = await Axios.patch(path, payload);
    if (response) {
      return {
        response,
        status: response.status,
      };
    }
  } catch (error) {
    throw(error)
  }
};